$shm_mentionstat_chart $shm_wordstat_chart_timeseries
	group? \day
	group_options *
	period_kind <= group_period_kind \
	sub /
		<= Tools $mol_view
			sub /
				<= Group_select $mol_select
					Filter null
					value? <=> group? \day
					dictionary <= group_options
		<= Chart
